import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'birchBark', d: 'M-0.5,-6h1v6.5h-1z' },
    {
      paint: 'bushDark',
      d: 'M1,-11h0.5v0.5h-0.5zM1.5,-10.5h0.5v0.5h-0.5zM1.5,-10h1v0.5h-1zM1,-9.5h1.5v0.5h-1.5zM1,-9h1v0.5h-1zM1,-8.5h1.5v1h-1.5zM0.5,-7.5h2v0.5h-2zM-0.5,-7h3v0.5h-3zM-2,-6.5h4v0.5h-4zM-1,-6h0.5v0.5h-0.5z',
    },
    {
      paint: 'leaf',
      d: 'M-1.5,-11h2.5v0.5h-2.5zM-1.5,-10.5h0.5v0.5h-0.5zM0,-10.5h1.5v0.5h-1.5zM-2,-10h0.5v0.5h-0.5zM-0.5,-10h2v0.5h-2zM-1,-9.5h2v0.5h-2zM-1.5,-9h2.5v0.5h-2.5zM-2.5,-8.5h3.5v0.5h-3.5zM-3,-8h4v0.5h-4zM-2.5,-7.5h3v0.5h-3zM-2.5,-7h2v0.5h-2z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-10.5h1v0.5h-1zM-1.5,-10h1v0.5h-1zM-2.5,-9.5h1.5v0.5h-1.5zM-2.5,-9h1v0.5h-1z',
    },
  ],
  pixels: 117,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'birchBark',
      d: 'M-0.5,-5.5h1v5.5h-1zM-3,-4h1v3.5h-1zM1.5,-3.5h1v3.5h-1zM-2.5,-0.5h1v0.5h-1zM-0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M1,-10.5h0.5v0.5h-0.5zM1.5,-10h0.5v0.5h-0.5zM1,-9.5h1v1.5h-1zM1,-8h1.5v1h-1.5zM0,-7h2v0.5h-2zM2.5,-7h0.5v0.5h-0.5zM-0.5,-6.5h2.5v0.5h-2.5zM3,-6.5h0.5v0.5h-0.5zM-1.5,-6h3v0.5h-3zM2.5,-6h1v1.5h-1zM-2,-5.5h1.5v0.5h-1.5zM-2.5,-5h2v0.5h-2zM-3.5,-4.5h2.5v0.5h-2.5zM2,-4.5h1.5v0.5h-1.5zM1,-4h2v0.5h-2z',
    },
    {
      paint: 'leaf',
      d: 'M-1,-10.5h2v0.5h-2zM-1.5,-10h0.5v0.5h-0.5zM0,-10h1.5v0.5h-1.5zM-0.5,-9.5h1.5v0.5h-1.5zM-1,-9h2v0.5h-2zM-1.5,-8.5h2.5v0.5h-2.5zM-3,-8h4v0.5h-4zM-3.5,-7.5h0.5v1h-0.5zM-2.5,-7.5h3.5v0.5h-3.5zM-2.5,-7h2.5v0.5h-2.5zM2,-7h0.5v0.5h-0.5zM-3,-6.5h2.5v0.5h-2.5zM2,-6.5h1v0.5h-1zM-4,-6h2.5v0.5h-2.5zM1.5,-6h1v0.5h-1zM-4,-5.5h2v0.5h-2zM1,-5.5h1.5v0.5h-1.5zM-4,-5h1.5v0.5h-1.5zM0.5,-5h2v0.5h-2zM0.5,-4.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-10h1v0.5h-1zM-1.5,-9.5h1v0.5h-1zM-2,-9h1v0.5h-1zM-2.5,-8.5h1v0.5h-1zM-3,-7.5h0.5v1h-0.5zM-4,-6.5h1v0.5h-1zM0.5,-5.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 196,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'birchBark',
      d: 'M-1.5,-5.5h1v2h-1zM-1.5,-3.5h1.5v1h-1.5zM-1,-2.5h0.5v0.5h-0.5zM-1,-2h1v1h-1zM-1,-1h1.5v1h-1.5zM-0.5,0h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1,-6h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'bushDark',
      d: 'M0,-11h0.5v0.5h-0.5zM0,-10.5h1v2h-1zM0,-8.5h1.5v1h-1.5zM-0.5,-7.5h2v0.5h-2zM-1,-7h2.5v0.5h-2.5zM-2,-6.5h3v0.5h-3zM-2.5,-6h1.5v0.5h-1.5z',
    },
    {
      paint: 'leaf',
      d: 'M-2.5,-11h2.5v0.5h-2.5zM-3,-10.5h0.5v1h-0.5zM-1,-10.5h1v0.5h-1zM-1.5,-10h1.5v0.5h-1.5zM-2,-9.5h2v0.5h-2zM-2.5,-9h2.5v1h-2.5zM-3.5,-8h3.5v0.5h-3.5zM-3.5,-7.5h3v0.5h-3zM-3.5,-7h2.5v0.5h-2.5zM-3,-6.5h1v0.5h-1z',
    },
    {
      paint: 'leafLight',
      d: 'M-2.5,-10.5h1.5v0.5h-1.5zM-2.5,-10h1v0.5h-1zM-3,-9.5h1v0.5h-1zM-3.5,-9h1v1h-1z',
    },
  ],
  pixels: 118,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
